import {
  getServiceUrl,
  getServicesAppUrl,
  getMapUrl,
} from '../utils/externalPages';

export const HEADER_MENU_ITEMS = [
  {
    label: 'wallet',
    data: [
      {
        title: 'home',
        path: `${getServiceUrl()}/wallets`,
      },
      {
        title: 'movements',
        path: `${getServiceUrl()}/wallets/movements`,
      },
      {
        title: 'profile',
        collapseData: [
          // {
          //   title: 'personalInformation',
          //   path: `${getServiceUrl()}/personal-information`,
          // },
          // {
          //   title: 'domicilie',
          //   path: `${getServiceUrl()}/domicilial-information`,
          // },
          {
            title: 'verificationCenter',
            path: `${getServiceUrl()}/settings/verification-center`,
          },
          {
            title: 'security',
            path: `${getServiceUrl()}/settings/security`,
          },
        ],
      },
      {
        title: 'banks',
        path: `${getServicesAppUrl()}/banks`,
      },
      {
        title: 'cards',
        path: `${getServiceUrl()}/wallets/cards`,
      },
      {
        title: 'wallets',
        path: `${getServiceUrl()}/wallets/list`,
      },
      {
        title: 'cashIn',
        path: `${getServicesAppUrl()}/broker?operation=cash-in&medium=Banco`,
      },
      {
        title: 'cashOut',
        path: `${getServicesAppUrl()}/broker?operation=cash-out&medium=Banco`,
      },
      {
        title: 'swap',
        path: `${getServiceUrl()}/wallets/swap`,
      },
      {
        title: 'k2p',
        path: `${getServiceUrl()}/k2p`,
      },
    ],
    dropdownMenuMinWidth: 200,
  },
  {
    label: 'commerces',
    data: [
      {
        title: 'posPayment',
        path: `/`,
      },
      {
        title: 'paymentHistory',
        path: `/payments`,
      },
      {
        title: 'myShop',
        collapseData: [
          {
            title: 'companyInformation',
            path: `${getServiceUrl()}/settings/comercios/my-store`,
          },
          {
            title: 'coinsTokens',
            path: `${getServiceUrl()}/settings/comercios/my-store/tokens-currencies`,
          },
          {
            title: 'shops',
            path: `${getServiceUrl()}/settings/comercios/my-store/locales`,
          },
        ],
      },
      {
        title: 'settings',
        path: `${getServiceUrl()}/settings/comercios`,
      },
      {
        title: 'report',
        path: `/reports`,
      },
      {
        title: 'users',
        path: `${getServiceUrl()}/settings/comercios/users`,
      },
    ],
    dropdownMenuMinWidth: 200,
  },
  {
    label: 'services',
    data: [
      {
        title: 'services',
        path: getServicesAppUrl(),
      },
      {
        title: 'kriptosearch',
        path: `${getServicesAppUrl()}/kriptosearch`,
      },
      {
        title: 'kriptostore',
        path: `${getServicesAppUrl()}/kriptostore`,
      },
      {
        title: 'payments',
        path: `${getServicesAppUrl()}/kriptopayment`,
      },
      {
        title: 'maps',
        path: getMapUrl(),
      },
      {
        title: 'marketplace',
        path: `${getServicesAppUrl()}/kriptosearch?country=ARG&provider=kriptonmarket`,
      },
    ],
    dropdownMenuMinWidth: 200,
  },
];
